import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';

function Menu() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button className="menu-toggle" onClick={toggleMenu} aria-label="Menu">
        <span className={`hamburger ${isOpen ? 'open' : ''}`}></span>
      </button>

      <nav className={`menu ${isOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li>
            <Link to="/services" onClick={closeMenu}>Services</Link>
          </li>
          <li>
            <Link to="/articles" onClick={closeMenu}>Articles</Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>About</Link>
          </li>
        </ul>
      </nav>

      {isOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </>
  );
}

export default Menu;
